<!-- 🚀 CONTENEDOR OPTIMIZADO: Fluido, responsivo y libre de barras horizontales -->
<!-- <div class="p-4 bg-white" style="font-size: 0.90rem; min-height: 100vh; overflow-y: auto; overflow-x: hidden; width: 100%;"> -->

  <!-- 🚀 CONTENEDOR INDEPENDIENTE: Adaptado para vista de pantalla completa fluida -->
<div class="container-fluid mt-3 px-4" style="font-size: 0.90rem;">  


  <div class="border-bottom pb-2 mb-4">
    <h3 class="h5 m-0 fw-bold text-dark">🚀 Desplegar Nueva Compañía (Inquilino Taller)</h3>
    <span class="small text-muted font-monospace">Global Enterprise Provisioning Wizard / SaaS Multi-Tenant</span>
  </div>

  <form [formGroup]="saasForm" (ngSubmit)="onSubmit()" autocomplete="off">

    <!-- Fila 1: Datos Core del Negocio y Régimen de la Empresa -->
    <div class="row g-3 mb-3">
      <div class="col-md-4">
        <div class="form-floating">
          <input type="text" class="form-control text-uppercase" id="saasName" formControlName="nameAlpha" placeholder="Razón Social"
                 appUppercase
                 [ngClass]="{'is-invalid': f['nameAlpha'].touched && f['nameAlpha'].invalid}">
          <label for="saasName">Razón Social Legal del Taller / Empresa *</label>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-floating">
          <input type="text" class="form-control text-uppercase" id="rfc" formControlName="rfc" placeholder="RFC"
                 appUppercase
                 [ngClass]="{'is-invalid': f['rfc'].touched && f['rfc'].invalid}"
                 placeholder="XAXX010101000">
          <label for="rfc" class="text-secondary">RFC / Identificación Fiscal de la Empresa *</label>
          <div class="invalid-feedback">
            <span *ngIf="f['rfc'].hasError('required')">El RFC de la empresa es requerido.</span>
            <span *ngIf="f['rfc'].hasError('pattern')">Ingrese un formato de RFC legal y válido.</span>
            <span *ngIf="f['rfc'].hasError('rfcRegimenInvalido')">{{ f['rfc'].getError('rfcRegimenInvalido') }}</span>
          </div>          
        </div>
      </div>

      <div class="col-md-4">
        <div class="form-floating">
          <select class="form-select" id="tax2" formControlName="tax2"
                  [ngClass]="{'is-invalid': f['tax2'].touched && f['tax2'].invalid}">
            <option *ngFor="let tipo of tiposPersona" [value]="tipo.codigo">
              {{ tipo.descripcion }}
            </option>
          </select>
          <label for="tax2" class="text-secondary">Régimen Fiscal (Empresa) *</label>
          <div class="invalid-feedback" *ngIf="f['tax2'].hasError('rfcRegimenInvalido')">
            Régimen incongruente con el RFC de la empresa.
          </div>
        </div>
      </div>
      
    </div>

    <!-- Fila 2: Representante, su RFC y su Régimen Propio -->
    <div class="row g-3 mb-3">
      <div class="col-md-4">
        <div class="form-floating">
          <input type="text" class="form-control text-uppercase" id="saasOwner" formControlName="ownerName" placeholder="Dueño"
                 [ngClass]="{'is-invalid': f['ownerName'].touched && f['ownerName'].invalid}">
          <label for="saasOwner">Nombre del Dueño / Representante *</label>
        </div>
      </div>

      <div class="col-md-4">
        <div class="form-floating">
          <input type="text" class="form-control text-uppercase" id="ownerRfc" formControlName="ownerRfc" placeholder="RFC Representante"
                 appUppercase
                 [ngClass]="{'is-invalid': f['ownerRfc'].touched && f['ownerRfc'].invalid}">
          <label for="ownerRfc" class="text-secondary">RFC del Dueño / Representante *</label>
          <div class="invalid-feedback">
            <span *ngIf="f['ownerRfc'].hasError('required')">El RFC del representante es requerido.</span>
            <span *ngIf="f['ownerRfc'].hasError('pattern')">Ingrese un formato de RFC válido para el representante.</span>
            <span *ngIf="f['ownerRfc'].hasError('rfcRegimenInvalido')">{{ f['ownerRfc'].getError('rfcRegimenInvalido') }}</span>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="form-floating">
          <select class="form-select" id="ownerTax2" formControlName="ownerTax2"
                  [ngClass]="{'is-invalid': f['ownerTax2'].touched && f['ownerTax2'].invalid}">
            <option *ngFor="let tipo of tiposPersona" [value]="tipo.codigo">
              {{ tipo.descripcion }}
            </option>
          </select>
          <label for="ownerTax2" class="text-secondary">Régimen Fiscal (Representante) *</label>
          <div class="invalid-feedback" *ngIf="f['ownerTax2'].hasError('rfcRegimenInvalido')">
            Régimen incongruente con el RFC del representante.
          </div>
        </div>
      </div>

    </div>


    <!-- Fila 3: Teléfono abajo -->
    <div class="row g-3 mb-3">
      <div class="col-md-12">
        <div class="form-floating">
          <!-- ⚡ CORREGIDO: Ahora usa la validación con .touched a través del getter 'f' -->
          <input type="text" class="form-control" id="saasPhone" formControlName="supportPhone" placeholder="Tel"
                 (keypress)="soloNumeros($event)"
                 [ngClass]="{'is-invalid': f['supportPhone'].touched && f['supportPhone'].invalid}">

          <!-- ⚡ CORREGIDO: Se quitó 'text-danger' fija. Ahora el label se vuelve rojo dinámicamente si hay un error -->
          <label for="saasPhone" [ngClass]="{'text-danger': f['supportPhone'].touched && f['supportPhone'].invalid}">
          Teléfono de Soporte y Atención *
          </label>

          <!-- ⚡ CORREGIDO: Condición limpia usando el getter 'f' -->
          <div class="invalid-feedback" *ngIf="f['supportPhone'].touched && f['supportPhone'].invalid">
          El teléfono es mandatorio para el soporte de la suscripción (10 dígitos).
          </div>
        </div>
      </div>
    </div>      


    <!-- 📍 SECCIÓN UBICACIÓN: ORGANIZADA EN BLOQUES DE 3 CAMPOS POR LÍNEA -->
    <div class="card p-3 bg-light border-0 mb-3" style="border-radius: 8px;">
      <span class="text-xs fw-bold text-dark text-uppercase mb-3 font-monospace" style="letter-spacing: 0.5px;">
        📍 Ubicación y Dirección Fiscal de la Sucursal / Matriz
      </span>
      
      <!-- Línea de Dirección 1: Calle, Colonia y Código Postal -->
      <div class="row g-3 mb-3">
        <div class="col-md-4">
          <div class="form-floating">
            <input type="text" class="form-control text-uppercase" id="saasCalle" formControlName="calleNumero" placeholder="Calle y Número"
                   appUppercase
                   [ngClass]="{'is-invalid': f['calleNumero'].touched && f['calleNumero'].invalid}">
            <label for="saasCalle">Calle, Avenida y Número *</label>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-floating">
            <input type="text" class="form-control text-uppercase" id="saasColonia" formControlName="colonia" placeholder="Colonia"
                   appUppercase
                   [ngClass]="{'is-invalid': f['colonia'].touched && f['colonia'].invalid}">
            <label for="saasColonia">Colonia / Fraccionamiento *</label>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-floating">
            <input type="text" class="form-control font-monospace text-center" id="saasCP" formControlName="codigoPostal" placeholder="C.P."
                   [ngClass]="{'is-invalid': f['codigoPostal'].touched && f['codigoPostal'].invalid}">
            <label for="saasCP">Código Postal *</label>
          </div>
        </div>
      </div>

      <!-- Línea de Dirección 2: Municipio, País (Select) y Estado (Select/Input Dinámico) -->
      <div class="row g-3 mb-3">
        <div class="col-md-4">
          <div class="form-floating">
            <input type="text" class="form-control text-uppercase" id="saasMunicipio" formControlName="delegacionMunicipio" placeholder="Municipio"
                   appUppercase
                   [ngClass]="{'is-invalid': f['delegacionMunicipio'].touched && f['delegacionMunicipio'].invalid}">
            <label for="saasMunicipio">Delegación o Municipio *</label>
          </div>
        </div>
        
        <!-- Menú Desplegable de País desde Tabla UDC -->
        <div class="col-md-4">
          <div class="form-floating">
            <select class="form-select" id="country" formControlName="country" (change)="onPaisCambiado($event)">
              <option value="">-- Seleccione País --</option>
              <option *ngFor="let p of paises" [value]="p.keyRef">
                {{ p.description }}
              </option>
            </select>
            <label for="country">País *</label>
          </div>
        </div>

        <!-- Campo de Estado Dinámico (Select vs Captura Libre) -->
        <div class="col-md-4">
          <!-- CASO MENU DESPLEGABLE UDC (MX / US) -->
          <div class="form-floating" *ngIf="mostrarDesplegableEstado">
            <select class="form-select" id="saasEstadoSelect" formControlName="estado"
                    [ngClass]="{'is-invalid': f['estado'].touched && f['estado'].invalid}">
              <option value="" disabled selected>-- SELECCIONE ESTADO --</option>
              <option *ngFor="let edo of estados" [value]="edo.keyRef">{{ edo.description || edo.keyRef }}</option>
            </select>
            <label for="saasEstadoSelect">Estado *</label>
          </div>
          
          <!-- CASO CAPTURA LIBRE MANUAL -->
          <div class="form-floating" *ngIf="!mostrarDesplegableEstado">
            <input type="text" class="form-control text-uppercase" id="saasEstadoInput" formControlName="estado" placeholder="Estado"
                   appUppercase
                   [ngClass]="{'is-invalid': f['estado'].touched && f['estado'].invalid}">
            <label for="saasEstadoInput">Estado (Captura Libre) *</label>
          </div>
        </div>
      </div>


      <!-- Línea de Dirección 3: Ciudad -->
      <div class="row g-3 mb-3">
        <div class="col-md-4">
          <div class="form-floating">
            <input type="text" class="form-control text-uppercase" id="ciudad" formControlName="ciudad" placeholder="Ciudad"
                   appUppercase
                   [ngClass]="{'is-invalid': f['ciudad'].touched && f['ciudad'].invalid}">
            <label for="ciudad">Ciudad *</label>
          </div>
        </div>      
      </div>

    </div>    


    <!-- Fila 2: Parametría Contable JDE -->
    <div class="card p-3 bg-light border-0 mb-3" style="border-radius: 8px;">
      <span class="text-xs fw-bold text-secondary text-uppercase mb-3 font-monospace" style="letter-spacing: 0.5px;">
        🏛️ Parametría Contable y Financiera JDE (Secuencia Automática F0002)
      </span>
      <div class="row g-3">
        <div class="col-md-5">
          <div class="form-floating">
            <input type="text" class="form-control font-monospace text-uppercase bg-light-subtle text-muted" id="saasMcu" formControlName="mcuBu" readonly>
            <label for="saasMcu">Business Unit (12 Char MCU) *</label>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-floating">
            <input type="text" class="form-control font-monospace text-center bg-light-subtle text-muted" id="saasCcco" formControlName="ccco" readonly>
            <label for="saasCcco">Company Code (5 Char CCCO) *</label>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-floating">
            <input type="text" class="form-control font-monospace text-center text-uppercase bg-light-subtle text-muted" id="saasCrdc" formControlName="crdc" readonly>
            <label for="saasCrdc">Moneda Base (CRDC) *</label>
          </div>
        </div>
      </div>
    </div>


    <!-- Fila 3: Credenciales Administrador -->
    <div class="card p-3 bg-light border-0 mb-4 border-start border-primary border-4" style="border-radius: 0 8px 8px 0;">
      <span class="text-xs fw-bold text-primary text-uppercase mb-3 font-monospace" style="letter-spacing: 0.5px;">
        🔑 Credenciales del Administrador Máster del Taller (ROLE_ADMIN)
      </span>
      <div class="row g-3">
        <div class="col-md-3">
          <div class="form-floating">
            <input type="text" class="form-control font-monospace text-lowercase" id="saasUser" formControlName="adminUser" placeholder="User"
                   [ngClass]="{'is-invalid': f['adminUser'].touched && f['adminUser'].invalid}">
            <label for="saasUser">Username Máster *</label>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-floating">
            <input type="password" class="form-control font-monospace" id="saasPass" formControlName="adminPassword" placeholder="Pass"
                   [ngClass]="{'is-invalid': f['adminPassword'].touched && f['adminPassword'].invalid}">
            <label for="saasPass">Contraseña Admin *</label>
          </div>
        </div>
        <div class="col-md-3">

          <div class="form-floating">
            <input type="text" class="form-control text-uppercase" id="email" formControlName="email"
                appUppercase
                [ngClass]="{'is-invalid': f['email'].touched && f['email'].invalid}" 
                placeholder="correo@empresa.com">
            <label for="email">Correo Electrónico Central *</label>

            <div class="invalid-feedback">
              <!-- Mensaje tradicional si lo dejan vacío -->
              <span *ngIf="saasForm.get('email')?.hasError('required')">El correo electrónico es obligatorio para el alta del cliente.</span>
              
              <!-- Mensaje tradicional si el formato está mal escrito -->
              <span *ngIf="saasForm.get('email')?.hasError('email')">Por favor ingrese un formato de correo válido.</span>
              
              <!-- MANTENIDO: El mensaje rojo estático abajo del campo que querías conservar -->
              <span *ngIf="saasForm.get('email')?.hasError('correoDuplicado')" class="fw-bold text-danger">
              ⚠️ Correo ya registrado en el sistema. Pertenece a un cliente existente en la base de datos.
              </span>
            </div>
          </div>

        </div>
        <div class="col-md-3">
          <div class="form-floating">
            <input type="number" class="form-control font-monospace bg-light-subtle text-muted" id="saasAn8" formControlName="adminAn8" readonly>
            <label for="saasAn8">Código AN8 Inicial *</label>
          </div>
        </div>
      </div>
    </div>


    <!-- Fila 4: Atributos Operativos y Control Legal -->
    <div class="card p-3 bg-light border-0 mb-4 border-start border-warning border-4" style="border-radius: 0 8px 8px 0;">
      <span class="text-xs fw-bold text-warning-emphasis text-uppercase mb-3 font-monospace" style="letter-spacing: 0.5px;">
        ⚖️ Atributos Operativos y Control Legal de Conformidad Jurídica
      </span>
      <div class="row g-3">
        <div class="col-md-4">
          <div class="form-floating">
            <select class="form-select" id="saasTipoTaller" formControlName="tipoTaller"
                    [ngClass]="{'is-invalid': f['tipoTaller'].touched && f['tipoTaller'].invalid}">
              <option value="MECANICO">MECÁNICO</option>
              <option value="LAMINADO">LAMINADO Y PINTURA</option>
              <option value="AMBOS">AMBOS (MECÁNICO Y LAMINADO)</option>
            </select>
            <label for="saasTipoTaller">Especialidad / Tipo de Taller *</label>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-floating">
            <input type="text" class="form-control font-monospace text-uppercase" id="saasRegProfeco" formControlName="numRegContAdhesion" placeholder="Contrato Adhesión"
                   [ngClass]="{'is-invalid': f['numRegContAdhesion'].touched && f['numRegContAdhesion'].invalid}">
            <label for="saasRegProfeco">No. Contrato Adhesión PROFECO *</label>
          </div>
        </div>

        <!-- Cuenta con Seguro (<select>) -->
        <div class="col-md-4">
          <div class="form-floating">
            <select class="form-select" id="saasCuentaSeguro" formControlName="tallerCuentaSeguro"
                    [ngClass]="{'is-invalid': f['tallerCuentaSeguro'].touched && f['tallerCuentaSeguro'].invalid}">
              <option value="SI">SÍ, CUENTA CON SEGURO VIGENTE</option>
              <option value="NO">NO CUENTA CON SEGURO</option>
            </select>
            <label for="saasCuentaSeguro">¿Cuenta con Póliza de Seguro? *</label>
          </div>
        </div>
      </div>
    </div>

    <!-- Switch de Suscripción (Ubicado elegantemente al pie izquierdo) -->
    <div class="row g-3 mb-4 align-items-center">
      <div class="col-12 ps-4">
        <div class="form-check form-switch ps-5">
          <input class="form-check-input shadow-sm" type="checkbox" id="saasSwitchEnabled" formControlName="enabled" style="scale: 1.25; cursor: pointer;">
          <label class="form-check-label fw-bold text-success ms-3" for="saasSwitchEnabled" *ngIf="saasForm.get('enabled')?.value">🟢 Suscripción Activa Inmediata</label>
          <label class="form-check-label fw-bold text-danger ms-3" for="saasSwitchEnabled" *ngIf="!saasForm.get('enabled')?.value">🔴 Cuenta Creada en Suspensión</label>
        </div>
      </div>
    </div>

    <!-- Botonera Ejecutiva Homologada con Estado Inhabilitado -->
    <div class="d-flex justify-content-end gap-2 border-top pt-3">
<!--       <button type="button" class="btn btn-light border fw-bold px-4" style="border-radius: 6px;" (click)="dialogRef.close(false)">
        Cancelar
      </button> -->

      <!-- 💡 SOLUCIÓN: Cambiamos <button> por <a> con routerLink para regresar a la lista de forma nativa -->
      <a class="btn btn-light border fw-bold px-4" style="border-radius: 6px;" routerLink="/admin/saas">
        Cancelar
      </a>
      
      <button 
        type="submit" 
        class="btn fw-bold text-white px-5 shadow-sm transition-all"
        [disabled]="saasForm.invalid"
        [ngClass]="saasForm.invalid ? 'btn-secondary opacity-50' : 'btn-success'"
        style="border-radius: 6px;">
        💾 Desplegar Taller
      </button>
    </div>

  </form>
</div>


<!-- 🌟 CONTENEDOR FLOTANTE DE TOASTS (BOOTSTRAP 5 NATIVO) -->
<div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1080; margin-top: 50px;">
  <div *ngFor="let toast of toastService.toasts" 
       class="toast show shadow border-0 mb-2" 
       [ngClass]="'bg-' + toast.type + '-subtle text-dark'"
       role="alert" aria-live="assertive" aria-atomic="true">
    
    <!-- Encabezado de la Alerta -->
    <div class="toast-header border-0 bg-transparent text-dark d-flex justify-content-between align-items-center">
      <strong class="me-auto d-flex align-items-center gap-2">
        <span *ngIf="toast.type === 'danger'">⚠️</span>
        <span *ngIf="toast.type === 'success'">✅</span>
        {{ toast.title }}
      </strong>
      <button type="button" class="btn-close" (click)="toastService.remove(toast)" aria-label="Close"></button>
    </div>
    
    <!-- Cuerpo de la Alerta -->
    <div class="toast-body pt-0" style="font-size: 0.85rem;">
      {{ toast.text }}
    </div>
  </div>
</div>